<template>
  <v-container fluid>
    <VueApexCharts
      width="100%"
      height="300"
      type="bar"
      :options="options"
      :series="series"
    />
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ChartVeiksmaiMenuo',
  components: {
    VueApexCharts,
  },
  props: {
    chart: Array,
    laikotarpis: String,
  },
  data() {
    return {
      //
    }
  },
  computed: {
    series() {
      return this.chart.map(item => {
        return {
          name: item.veiksmas,
          data: [item.hipoteka, item.ikeitimas, item.vykdomasis, item.sutartis],
        }
      })
    },
    seriesDemo() {
      return [
        {
          name: 'Įregistravimas',
          data: [30, 20, 41, 15],
        },
        {
          name: 'Pakeitimas',
          data: [32, 20, 30, 5],
        },
        {
          name: 'Išregistravimas',
          data: [30, 21, 32, 24],
        },
      ]
    },
    options() {
      return {
        plotOptions: {
          bar: {
            distributed: false,
            borderRadius: 3,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        chart: {
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '10px',
            colors: ['#304758'],
          },
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
        },
        legend: {
          show: true,
        },
        xaxis: {
          categories: [
            'Hipotekos',
            'Įkeitimai',
            'Vykdomieji įrašai',
            'Sutartys',
          ],
          position: 'bottom',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function(val) {
              return val
            },
          },
        },
        title: {
          text: `Atlikti veiksmai (${this.laikotarpis})`,
          floating: true,
          offsetY: 0,
          align: 'center',
          style: {
            color: '#444',
            fontSize: '16px',
            fontFamily: 'Open Sans',
          },
        },
      }
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
